import { apiClient } from '~/services/api-service';

export const appMicrositeAPIService = {
  createAppSite: (body) => {
    return apiClient.post(`/microsite/app/`, body);
  },
  updateAppSite: ({ id, body }) => {
    return apiClient.patch(`/microsite/app/${id}/`, body);
  },
};
